/**
 * EmailDestinatarioCollection
 *
 * @author Simpli CLI generator
 */
import {PageCollection, HttpExclude, Request} from 'simpli-web-sdk'
import {EmailDestinatario} from '@/model/resource/EmailDestinatario'

/* TODO: review generated class */
@HttpExclude()
export class EmailDestinatarioCollection extends PageCollection<
  EmailDestinatario
> {
  constructor() {
    super(EmailDestinatario)
  }

  queryAsPage() {
    return this.listEmailDestinatario()
  }

  async listEmailDestinatario() {
    return await Request.get(`/admin/email-destinatario`, {params: this.params})
      .name('listEmailDestinatario')
      .as(this)
      .getResponse()
  }

  async listCsvEmailDestinatario() {
    return await Request.get(`/admin/email-destinatario/csv`, {
      params: this.params,
    })
      .name('listCsvEmailDestinatario')
      .as(this)
      .getResponse()
  }
}
